"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Wrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  name: '',
  label: '',
  hasError: false,
  children: null,
  doNotShowErrors: false,
  labelSize: 10,
  errors: null
};
function InputFeedback(props) {
  const {
    label,
    name,
    hasError,
    errors,
    children,
    doNotShowErrors,
    labelSize,
    width,
    className,
    styles
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    labelSize: labelSize,
    className: className,
    width: width,
    styles: styles
  }, label && /*#__PURE__*/_react.default.createElement(Label, {
    htmlFor: name
  }, label), children, !doNotShowErrors ? /*#__PURE__*/_react.default.createElement(ErrorMessage, {
    hasError: hasError,
    "aria-live": "polite"
  }, errors === null || errors === void 0 ? void 0 : errors.message) : null);
}
const Wrapper = exports.Wrapper = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: ", ";\n\n\n  label {\n    font-weight: bold;\n    ", "\n  }\n\n  ", "\n"])), _ref => {
  let {
    width
  } = _ref;
  return width;
}, _ref2 => {
  let {
    labelSize
  } = _ref2;
  return "font-size: ".concat(labelSize, "px;");
}, _ref3 => {
  let {
    styles
  } = _ref3;
  return styles;
});
const Label = _styled.default.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
const ErrorMessage = _styled.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-align: end;\n  padding: 0 5px;\n  height: 15px;\n  font-size: 10px;\n\n  ", "\n"])), _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.MAIN.ERROR;
}, _ref5 => {
  let {
    hasError
  } = _ref5;
  return !hasError && 'opacity: 0;';
});
var _default = exports.default = InputFeedback;